import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
//import apiService from '../services/apiservices'
//import { productUpdateStockTableReady} from '../redux/employees'


//import * as Constants from '../../../common/constants'
import '../../../static/css/react-bootstrap-table.css'
import '../static/css/productKits.css'

class KitsCollapsibleRow extends Component {
    constructor() {
        super()
        this.state = {
        }
        this.dialog = null
    }
    

    

    render() {
        const options = {
            page: 1,  // which page you want to show as default
            sizePerPage: 10,  // which size per page you want to locate as default
        }
        return (
            <div style={{ backgroundColor: "#e1e5ed",margin: "0% 4%" }}>
                <Dialog ref={el => this.dialog = el} />
                <BootstrapTable
                    className="table-border"
                    options={options}
                    data={this.props.row.kits}
                    hover={false}
                    headerStyle={{ border: '0px', color: '#000' }}
                    tableStyle={{ border: '0px' }}
                    bodyStyle={{ border: '0px', overflow: "auto" }}>

                    <TableHeaderColumn
                        dataField="id"
                        width="1"
                        isKey={true}
                        hidden={true}
                        expandable={false}
                        dataAlign='center'
                        tdStyle={{ whiteSpace: 'normal'}}>
                        Id
                    </TableHeaderColumn>
                    

                    <TableHeaderColumn
                        dataField="sequence"
                        className="table-header"
                        columnClassName="table-body"
                        dataAlign='left'
                        thStyle={{ whiteSpace: 'normal',color:'white',background :"#f0b209", textAlign:'left'}}>
                        Sequence
                    </TableHeaderColumn> 
                    <TableHeaderColumn
                        dataField="name"
                        className="table-header"                        
                        columnClassName="table-body"
                        dataAlign='left'
                        thStyle={{ whiteSpace: 'normal',color:'white',background :"#f0b209", textAlign:'left'}}>
                        Name
                    </TableHeaderColumn>    

                    <TableHeaderColumn
                        dataField="description"
                        className="table-header"
                        columnClassName="table-body"
                        dataAlign='left'
                        thStyle={{ whiteSpace: 'normal',color:'white',background :"#f0b209", textAlign:'left'}}>
                        Description
                    </TableHeaderColumn>      

                    <TableHeaderColumn
                        dataField="quantity"
                        className="table-header"
                        columnClassName="table-body"
                        dataAlign='left'
                        thStyle={{ whiteSpace: 'normal',color:'white',background :"#f0b209", textAlign:'left'}}>
                        Quantity
                    </TableHeaderColumn>                     
                
                    <TableHeaderColumn
                        dataField="uom"
                        className="table-header"
                        columnClassName="table-body"
                        dataAlign='left'
                        thStyle={{ whiteSpace: 'normal',color:'white',background :"#f0b209", textAlign:'left'}}>
                        UOM
                    </TableHeaderColumn>    
                    <TableHeaderColumn
                        dataField="estimated_cost"
                        className="table-header"
                        columnClassName="table-body"
                        dataAlign='left'
                        thStyle={{ whiteSpace: 'normal',color:'white',background :"#f0b209", textAlign:'left'}}>
                        Est. Cost
                    </TableHeaderColumn>                      
                
                </BootstrapTable>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        employees: state.employees
    }
}

export default connect(mapStateToProps)(withRouter(KitsCollapsibleRow))


// WEBPACK FOOTER //
// ./src/modules/Kits/Components/KitsCollapsibleRow.js